export default "__VITE_ASSET__DlbYtXOF__"